import { createContext } from 'react';

export const MapViewContext = createContext({});

export const MapViewProvider = MapViewContext.Provider;
export const MapViewConsumer = MapViewContext.Consumer;
